import { render, staticRenderFns } from "./main.retefuente.vue?vue&type=template&id=3fb1a87d"
import script from "./main.retefuente.vue?vue&type=script&lang=js"
export * from "./main.retefuente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports